export default "__VITE_ASSET__KaVhzXkzjufM$V9UGX96eQ__"